import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Select from "react-select";
import globalContext from "../../Contexts/GlobalContext";

import "./BrandSelect.css";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { useNavigate } from "react-router-dom";
import useRequestHeader from "../../hooks/useRequestHeader";
// const options = [
//   { value: "ایران خودرو", label: "ایران خودرو" },
//   { value: "سایپا", label: "سایپا" },
//   { value: "BMW", label: "BMW" },
// ];

// const customStyles = {
//   control: (base, state) => ({
//     ...base,
//     background: "#00333C",
//     color: "#FFF",
//     border: state.isFocused ? 1 : 1,
//     boxShadow: "none",
//     border: "1px solid #00F7FF",
//     height: "10vw",
//     fontFamily: "brandsFont",
//     textAlighn: "left",
//     fontSize: "1.45vw",
//   }),

//   option: (base) => ({
//     ...base,
//     color: "#FFF",
//     border: "none",
//     background: "transparent",
//     fontFamily: "brandsFont",
//     textAlighn: "left",
//   }),
//   singleValue: (base) => ({
//     ...base,
//     color: "#FFF",
//     border: "none",
//     fontFamily: "brandsFont",
//     textAlighn: "left",
//   }),
//   menu: (base) => ({
//     ...base,
//     borderRadius: 0,
//     marginTop: 0,
//     background: "#2F3335",
//   }),
//   menuList: (base) => ({
//     ...base,
//     padding: 0,
//     background: "#2F3335",
//     "::-webkit-scrollbar": {
//       width: "9px",
//     },
//     "::-webkit-scrollbar-track": {
//       background: "#555",
//     },
//     "::-webkit-scrollbar-thumb": {
//       background: "#00F7FF",
//     },
//     "::-webkit-scrollbar-thumb:hover": {
//       background: "#555",
//     },
//   }),
// };

export default function BrandSelect({
  setBrand,
  brand,
  disabled = false,
  setNewBrand,
  carID = "IRI",
}) {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: `${carID?.includes("IRI") ? "#00333C" : "#181f21"}`,
      color: "#FFF",
      border: state.isFocused ? 1 : 1,
      boxShadow: "none",
      border: `1px solid ${carID?.includes("IRI") ? "#00F7FF" : "#9E9B96"} `,
      minHeight: "21px",
      height: "10vw",
      fontFamily: "brandsFont",
      textAlighn: "left",
      fontSize: "3.5vw",
      padding: "0px 0px 0px 8px",
    }),

    option: (base) => ({
      ...base,
      color: "#FFF",
      border: "none",
      background: "transparent",
      fontFamily: "brandsFont",
      textAlighn: "left",
    }),
    singleValue: (base) => ({
      ...base,
      color: `${carID.includes("IRI") ? "#FFF" : "#8f8c85"}`,
      border: "none",
      fontFamily: "brandsFont",
      textAlighn: "left",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      background: "#2F3335",
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      background: "#2F3335",
      "::-webkit-scrollbar": {
        width: "9px",
      },
      "::-webkit-scrollbar-track": {
        background: "#555",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#00F7FF",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "10vw",
      padding: "0 0",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "10vw",
      fontSize: "180px",
      color: "red",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const [notCom, setNotCom] = useState(false);

  const [cookies, setCookies, removeCookies] = useCookies();
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);

  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const [isBrandDis, setIsBrandDis] = useState(disabled);
  useEffect(() => {
    setIsBrandDis(disabled);
  }, [disabled, isBrandDis]);
  useEffect(() => {
    // if (notCom) {
    //   if (infoModeContextData?.infoModeBrand) {
    //     setSelectedOption(
    //       options.find((item) => {
    //         return item.label === infoModeContextData?.infoModeBrand;
    //       })
    //     );
    //     let f = options.find((item) => {
    //       if (item.label === infoModeContextData?.infoModeBrand) {
    //         return item;
    //       }
    //     });
    //     contextData.setContextCategoryID(f.value);
    //   }
    // }
  }, [notCom]);

  // ----->
  //// useeffect for get category id start ////
  /// base url section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// base url section end ///
  const [responseBrand, setResponseBrand] = useState("");
  useEffect(() => {
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/category`,
        {
          type: "cars",
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            if (res?.data?.Data?.category) {
              let ext = [];

              res?.data?.Data?.category?.map((item) => {
                if (item.parentID == "0") {
                  ext.push({ value: item.id, label: item.title });
                }
              });

              setOptions(ext);
              setNotCom(true);
            }
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
      })
      .catch((err) => {});
  }, []);
  //// useeffect for get category id end ////
  useEffect(() => {
    setSelectedOption(options.find((item) => item.label == brand));
    let f = options.find((item) => {
      if (item.label == brand) {
        return item;
      }
    });
    contextData?.setContextCategoryID(f?.value);
  }, [brand, options]);

  return (
    <Select
      styles={customStyles}
      options={options}
      value={selectedOption}
      isDisabled={carID?.includes("IRI") ? false : true}
      menuPortalTarget={document.body}
      placeholder={<p className="font-font_primary_A">انتخاب نمایید</p>}
      onChange={(e) => {
        setBrand(e.label);
        setSelectedOption(e);
        if (setNewBrand) {
          setNewBrand(e.label);
        }
        contextData.setContextCategoryID(e.value);
      }}
    />
  );
}
